import React, {useEffect, useRef, useState} from 'react';
import Flickity from "react-flickity-component";

const Carousel = () => {
  const flickityOptions = {
    initialIndex: 3,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    freeScroll: true,
  }

  return (
    <Flickity
      className={'carousel-container'}
      elementType={'div'}
      options={flickityOptions}
      >
      <div className="item">
        <div className="content">
          <p>“This is great! I love FB buy sell group for great deals of handbags and fashion.
            I now love it even more with POD. I can now buy from FB groups across the country.”</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-female.png" alt="Vicky Lopez" />
          <div className="author-info">
            <h3>Vicky Lopez</h3>
            <p>Blogger/Fashion guru, FB group lovers</p>
          </div>
        </div>
      </div>

      <div className="item">
        <div className="content">
          <p>“We found a great deal on baby stroller in a Facebook buy sell group. We used PayOnDelivery to secure
            the deal and get the item shipped to our home.”</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-male.png" alt="Cole Quinn" />
          <div className="author-info">
            <h3>Cole Quinn</h3>
            <p>Sales Manager, Dad</p>
          </div>
        </div>
      </div>

      <div className="item">
        <div className="content">
          <p>I bought a side table from a seller on Facebook Marketplace at 8:03am, I had it delivered at 10:04am. Effortless!</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-female.png" alt="Linda Michaud" />
          <div className="author-info">
            <h3>Linda Michaud</h3>
            <p>Freelancer, Love deals!</p>
          </div>
        </div>
      </div>

      <div className="item">
        <div className="content">
          <p>“This is great! I love FB buy sell group for great deals of handbags and fashion.
            I now love it even more with POD. I can now buy from FB groups across the country.”</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-female.png" alt="Vicky Lopez" />
          <div className="author-info">
            <h3>Vicky Lopez</h3>
            <p>Blogger/Fashion guru, FB group lovers</p>
          </div>
        </div>
      </div>

      <div className="item">
        <div className="content">
          <p>“We found a great deal on baby stroller in a Facebook buy sell group. We used PayOnDelivery to secure
            the deal and get the item shipped to our home.”</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-male.png" alt="Cole Quinn" />
          <div className="author-info">
            <h3>Cole Quinn</h3>
            <p>Sales Manager, Dad</p>
          </div>
        </div>
      </div>

      <div className="item">
        <div className="content">
          <p>I bought a side table from a seller on Facebook Marketplace at 8:03am, I had it delivered at 10:04am. Effortless!</p>
        </div>
        <div className="author d-flex">
          <img src="/images/v2/avatar-female.png" alt="Linda Michaud" />
          <div className="author-info">
            <h3>Linda Michaud</h3>
            <p>Freelancer, Love deals!</p>
          </div>
        </div>
      </div>
    </Flickity>
  )

  return (
    <div className="carousel-container" ref={containerRef}>
      <div className="carousel-items-container d-flex" ref={itemsRef}>

      </div>
    </div>
  );
}

export default Carousel;
